// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DriverLeadRepoManager from "../../domain/repo/DriverLeadRepoManager.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as DriverLeadPageViewStore from "../view-modal/view-store/DriverLeadPageViewStore.bs.js";
import * as DriverPaymentHistoryVMMapper from "../view-modal/vm-mapper/DriverPaymentHistoryVMMapper.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";
import * as DriverPartnerPageAssestsManager from "../assets/DriverPartnerPageAssestsManager.bs.js";

function DriverPaymentHistoryCmp$DisplayPaymentInfoCmp(Props) {
  var cmp_type = Props.cmp_type;
  var row = Props.row;
  return React.createElement("div", {
              className: cmp_type === /* Header */0 ? "info-headers" : "info-details"
            }, Belt_List.toArray(List.map((function (value) {
                        return React.createElement("div", undefined, value);
                      }), row)));
}

var DisplayPaymentInfoCmp = {
  make: DriverPaymentHistoryCmp$DisplayPaymentInfoCmp
};

function DriverPaymentHistoryCmp(Props) {
  var lead_id = Props.lead_id;
  var country = Props.country;
  var match = React.useState(function () {
        return true;
      });
  var setIsCollapsed = match[1];
  var isCollapsed = match[0];
  var match$1 = React.useState(function () {
        return /* Init */0;
      });
  var setPaymentHistoryInfo = match$1[1];
  var paymentHistoryInfo = match$1[0];
  var fetchDriverPaymentHistory = function (param) {
    var RepoInstance = DriverLeadRepoManager.getRepo(undefined);
    Curry._1(setPaymentHistoryInfo, (function (param) {
            return {
                    TAG: /* Loading */0,
                    _0: undefined
                  };
          }));
    return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                  return Curry._2(RepoInstance.fetchDriverPaymentHistory, lead_id, country);
                }), (function (data) {
                  return Curry._1(setPaymentHistoryInfo, (function (param) {
                                return {
                                        TAG: /* Live */1,
                                        _0: data
                                      };
                              }));
                }), (function (error) {
                  return Curry._1(setPaymentHistoryInfo, (function (param) {
                                return {
                                        TAG: /* Error */2,
                                        _0: error
                                      };
                              }));
                }));
  };
  React.useEffect((function () {
          if (typeof paymentHistoryInfo === "number" && isCollapsed === false) {
            fetchDriverPaymentHistory(undefined);
          }
          
        }), [
        isCollapsed,
        paymentHistoryInfo
      ]);
  var tmp;
  if (typeof paymentHistoryInfo === "number") {
    tmp = React.createElement(CircularLoader$Catalyst.make, {});
  } else {
    switch (paymentHistoryInfo.TAG | 0) {
      case /* Loading */0 :
          tmp = React.createElement(CircularLoader$Catalyst.make, {});
          break;
      case /* Live */1 :
          var responseData = paymentHistoryInfo._0;
          tmp = Belt_List.toArray(responseData.payment_history).length > 0 ? React.createElement("div", {
                  className: "info-wrapper"
                }, React.createElement(DriverPaymentHistoryCmp$DisplayPaymentInfoCmp, {
                      cmp_type: /* Header */0,
                      row: {
                        hd: DriverLeadPageViewStore.amount_title,
                        tl: {
                          hd: DriverLeadPageViewStore.payment_status_title,
                          tl: {
                            hd: DriverLeadPageViewStore.transaction_id_title,
                            tl: {
                              hd: DriverLeadPageViewStore.time_stamp_title,
                              tl: /* [] */0
                            }
                          }
                        }
                      }
                    }), Belt_List.toArray(List.map((function (payment_info) {
                            return React.createElement(DriverPaymentHistoryCmp$DisplayPaymentInfoCmp, {
                                        cmp_type: /* Info */1,
                                        row: {
                                          hd: payment_info.amount,
                                          tl: {
                                            hd: payment_info.status,
                                            tl: {
                                              hd: Belt_Option.getWithDefault(payment_info.transaction_id, "--"),
                                              tl: {
                                                hd: payment_info.updated_at,
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        },
                                        key: payment_info.updated_at
                                      });
                          }), DriverPaymentHistoryVMMapper.getPaymentHistoryInfoView(responseData)))) : React.createElement("div", {
                  className: "empty-state"
                }, React.createElement("h3", undefined, DriverLeadPageViewStore.empty_reg_fee_payment_message));
          break;
      case /* Error */2 :
          tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
                error: paymentHistoryInfo._0
              });
          break;
      
    }
  }
  return React.createElement("div", {
              className: "driver-miscellaneous-info-info-wrapper"
            }, React.createElement("div", {
                  className: "accordion-wrapper " + (
                    isCollapsed ? " accordion-wrapper__collapse" : " "
                  )
                }, React.createElement("div", {
                      className: "accordion-header"
                    }, React.createElement("div", {
                          className: "accordion-title"
                        }, React.createElement("img", {
                              src: DriverPartnerPageAssestsManager.getImage("payment-icon.svg")
                            }), React.createElement("div", {
                              className: "title"
                            }, DriverLeadPageViewStore.payment_history_title)), React.createElement("img", {
                          className: "accordion-icon",
                          src: DriverPartnerPageAssestsManager.getImage("accordion-arrow-icon.svg"),
                          onClick: (function (param) {
                              return Curry._1(setIsCollapsed, (function (prev) {
                                            return !prev;
                                          }));
                            })
                        })), React.createElement("div", {
                      className: "accordion-body"
                    }, React.createElement("div", {
                          className: "body-inner"
                        }, tmp))));
}

var make = DriverPaymentHistoryCmp;

export {
  DisplayPaymentInfoCmp ,
  make ,
  
}
/* react Not a pure module */
